import { mountApp } from '@/lib/helpers';

import App from './app.vue';

mountApp('[data-pack]', 'pack', App);
